module.exports = __webpack_public_path__ + "img/card-compare-sowhatbuy.3a2522ae.webp";